import { IconSVG } from '../types';

export const Alert = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 22 18"
      style={style}
    >
      <path
        fill="currentColor"
        d="M1.725 18a.973.973 0 01-.85-.5 1.098 1.098 0 01-.138-.488.898.898 0 01.138-.512l9.25-16c.1-.167.229-.292.387-.375C10.671.042 10.833 0 11 0c.166 0 .329.042.487.125a.984.984 0 01.388.375l9.25 16c.1.167.146.337.137.512a1.098 1.098 0 01-.137.488.973.973 0 01-.85.5H1.725zm1.725-2h15.1L11 3 3.45 16zM11 15c.283 0 .52-.096.712-.287A.968.968 0 0012 14a.968.968 0 00-.288-.713A.968.968 0 0011 13a.968.968 0 00-.713.287A.968.968 0 0010 14c0 .283.096.52.287.713.192.191.43.287.713.287zm0-3c.283 0 .52-.096.712-.287A.968.968 0 0012 11V8a.967.967 0 00-.288-.713A.968.968 0 0011 7a.968.968 0 00-.713.287A.967.967 0 0010 8v3c0 .283.096.52.287.713.192.191.43.287.713.287z"
      />
    </svg>
  );
};
